export default "__VITE_ASSET__mfcduJFK__"